export const UptimeRoute = {
  Uptime: (): string => '/profile/uptime',
};
